import 'picturefill'
import 'lazysizes'
// import $ from 'jquery'
import Alpine from 'alpinejs'

// Modules
import LoadMore from './modules/loadmore'
import LanguageSwitcher from './modules/languageswitcher'

// Components
import Swiper from 'swiper/bundle'
import 'swiper/swiper-bundle.css'

import MicroModal from 'micromodal'

window.Alpine = Alpine
// Alpine.data('navbar', navbar)
Alpine.start()

LoadMore.init()
LanguageSwitcher.init()


const initSwiper = () => {
    if (document.querySelector('.swiper-container')) {
        const swiper = new Swiper('.swiper-container', {
            slidesPerView: 'auto',
            spaceBetween: 30,
            scrollbar: {
                el: '.swiper-scrollbar',
            },
        })

        const next = document.querySelector('#next')
        const previous = document.querySelector('#previous')
        const disabledClass = 'swiper-custom-button--disabled'
        next.addEventListener('click', () => {
            swiper.slideNext()
        })
        previous.addEventListener('click', () => {
            swiper.slidePrev()
        })

        swiper.on('reachEnd', () => {
            next.classList.add(disabledClass)
            next.disabled = true
        })
        swiper.on('reachBeginning', () => {
            previous.classList.add(disabledClass)
            previous.disabled = true
        })

        swiper.on('fromEdge', () => {
            ;[next, previous].forEach((el) => {
                el.disabled = false
                el.classList.remove('swiper-custom-button--disabled')
            })
        })
    }
}

MicroModal.init({
    disableScroll: true,
})

initSwiper()

window.addEventListener('swiper-init', () => initSwiper())
function initCollapsibles() {
    const collapsibles = document.querySelectorAll('[data-collapsible]');

    if (collapsibles.length) {
        collapsibles.forEach((collapsible) => {
            const trigger = collapsible.querySelector('[data-collapsible-trigger]');
            const panel = collapsible.querySelector('[data-collapsible-panel]');
            const icon = collapsible.querySelector('[data-collapsible-icon]');
            const chevron = collapsible.querySelector('[data-collapsible-chevron]');

            // Only set initial styles if not already set
            if (!panel.style.maxHeight) {
                panel.style.maxHeight = '0px';
                panel.style.overflow = 'hidden';
                panel.style.transition = 'max-height 0.3s ease';
                trigger.style.cursor = 'pointer';
                chevron.style.transition = 'transform 0.2s ease-out';
            }

            const style = getComputedStyle(icon);

            function updatePanelHeight() {
                if (panel.classList.contains('expanded')) {
                    panel.style.maxHeight = panel.scrollHeight + 'px';
                }
            }

            trigger.addEventListener('click', (event) => {
                requestAnimationFrame(() => {
                    if (panel.classList.contains('expanded')) {
                        panel.style.maxHeight = '0px';
                        panel.style.padding = null;
                        chevron.style.transform = null;
                        panel.classList.remove('expanded');
                    } else {
                        panel.classList.add('expanded');
                        panel.style.maxHeight = panel.scrollHeight + 'px';
                        panel.style.marginLeft = icon.offsetWidth + parseInt(style.marginRight) + 'px';
                        chevron.style.transform = 'rotate(180deg)';
                    }
                })
            });

            // Use ResizeObserver to handle content changes
            const resizeObserver = new ResizeObserver(updatePanelHeight);
            resizeObserver.observe(panel);
        });
    }
}

// Initialize on load
document.addEventListener('DOMContentLoaded', () => {
    MicroModal.init({
        disableScroll: true,
        onShow: (modal) => {
            console.log('Modal show triggered');
            const container = modal.querySelector('.modal__container');
            if (container) {
                console.log('Initial state:', {
                    scrollTop: container.scrollTop,
                    height: container.scrollHeight,
                    windowWidth: window.innerWidth,
                    computedMaxHeight: window.getComputedStyle(container).maxHeight
                });

                // Initial reset
                container.scrollTop = 0;
                console.log('After initial reset:', container.scrollTop);

                // Track animation state
                let isAnimating = true;

                // Watch for DOM changes during animation only
                const observer = new MutationObserver((mutations) => {
                    if (!isAnimating) return;

                    console.log('Mutation during animation:', {
                        scrollTopBefore: container.scrollTop,
                        mutations: mutations.map(m => ({
                            type: m.type,
                            target: m.target.tagName,
                            attributeName: m.attributeName
                        }))
                    });
                    container.scrollTop = 0;
                    console.log('After mutation scroll reset:', container.scrollTop);
                });

                observer.observe(container, {
                    childList: true,
                    subtree: true,
                    attributes: true
                });

                // Frame checking only during animation
                let frameCount = 0;
                const checkScroll = () => {
                    if (!isAnimating) return;

                    frameCount++;
                    if (container.scrollTop !== 0) {
                        console.log(`Frame ${frameCount}: Scroll changed to:`, container.scrollTop);
                        container.scrollTop = 0;
                        console.log(`Frame ${frameCount}: Reset to:`, container.scrollTop);
                    }
                    requestAnimationFrame(checkScroll);
                };
                requestAnimationFrame(checkScroll);

                // Stop everything after animation duration (300ms is your animation duration)
                setTimeout(() => {
                    isAnimating = false;
                    observer.disconnect();
                    console.log(`Animation complete after ${frameCount} frames. Final scroll position:`, container.scrollTop);
                }, 300); // Match this to your animation duration
            }
        }
    })
    initCollapsibles();
});

// Update heights on window resize
window.addEventListener('resize', () => {
    document.querySelectorAll('[data-collapsible-panel].expanded').forEach(panel => {
        panel.style.maxHeight = panel.scrollHeight + 'px';
    });
});